import type {CreateExtArgs} from '@wix/document-manager-core'
import type {Pointer} from '@wix/document-services-types'
import type {DataModelExtensionAPI} from '../dataModel/dataModel'
import {DATA_TYPES} from '../../constants/constants'
import {POPUP_CONTAINER} from './consts'

const getPopupContainer = ({dal, pointers}: CreateExtArgs, popupPagePointer: Pointer) => {
    const childrenPointers = pointers.structure.getChildren(popupPagePointer)

    if (childrenPointers.length > 1) {
        throw new Error(
            `More than one child of the popup page was found. A popup page must have only single direct child of type ${Array.from(
                Object.values(POPUP_CONTAINER)
            ).join(', ')}`
        )
    }
    if (childrenPointers.length < 1) {
        throw new Error('No direct child of the popup page was found')
    }

    let candidatePointer = childrenPointers[0]
    const candidateType = dal.get(pointers.getInnerPointer(candidatePointer, 'componentType'))

    if (!Object.values(POPUP_CONTAINER).includes(candidateType)) {
        throw new Error(
            `Direct child of the popup is of type ${candidateType}. Expected types: ${Array.from(
                Object.values(POPUP_CONTAINER)
            ).join(', ')}`
        )
    }

    if (candidateType === POPUP_CONTAINER.BUILDER_SYSTEM) {
        const builderPopupContainerChildren = pointers.structure.getChildren(candidatePointer)
        if (builderPopupContainerChildren.length !== 1) {
            throw new Error(
                `${POPUP_CONTAINER.BUILDER_SYSTEM} must have exactly one child. Found ${builderPopupContainerChildren.length} children`
            )
        }
        candidatePointer = builderPopupContainerChildren[0]
    }

    return candidatePointer
}

export const isPopup = ({pointers, dal}: CreateExtArgs, pageId: string) => {
    if (pageId === 'masterPage') {
        return false
    }

    const pageDataItemPointer = pointers.data.getDataItemFromMaster(pageId)
    const pageData = dal.get(pageDataItemPointer)
    return pageData?.isPopup
}

export const isPopupFullWidth = (createExtArgs: CreateExtArgs, popupPointer: Pointer) => {
    const {dataModel} = createExtArgs.extensionAPI as DataModelExtensionAPI

    const popupContainerPointer = getPopupContainer(createExtArgs, popupPointer)
    const popupContainerProps = dataModel.components.getItem(popupContainerPointer, DATA_TYPES.prop)
    return popupContainerProps.alignmentType === 'fullWidth'
}

export const getContainerToAddTo = (createExtArgs: CreateExtArgs, containerPointer: Pointer): Pointer => {
    if (createExtArgs.pointers.structure.isPage(containerPointer) && isPopup(createExtArgs, containerPointer.id)) {
        return getPopupContainer(createExtArgs, containerPointer)
    }

    return containerPointer
}
